import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Assuming react-router-dom v6+
import ScreenerList from "./static/ScreenerList";

import KycNotification from "../components/static/kyc/kyc_notification";
import OverviewComponent from "./static/overviewComponent";
import ChatbotWidget from "../../src/components/features/Support/ChatbotWidget";

function Dashboard() {
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const hasRefreshed = localStorage.getItem("dashboardRefreshed");

    if (!hasRefreshed && isInitialLoad) {
      localStorage.setItem("dashboardRefreshed", "true");
      setIsInitialLoad(false);
      window.location.reload();
    }
  }, [isInitialLoad]);

  if (!localStorage.getItem("dashboardRefreshed")) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-700"></div>
      </div>
    );
  }

  // Main Dashboard Layout
  return (
    <div className="min-h-screen bg-gray-50 pt-0">
      <div className="flex h-[calc(100vh-6rem)] overflow-hidden">
        <aside className="hidden md:flex md:flex-col w-80 bg-white shadow-md fixed top-20 left-0 h-[calc(100vh-5rem)] overflow-hidden z-30">
          {/* Sidebar Header */}
          <div className="flex-shrink-0 p-6  bg-white z-10">
            {/* <h2 className="text-xl font-bold text-gray-800 mb-4">Screeners</h2>
            <button
              className="w-full px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition" // Added focus styles
              onClick={() => navigate('/screener')}
            >
              New Screener
            </button> */}
          </div>
          {/* Scrollable Sidebar List */}
          <div className="flex-1 overflow-y-auto">
            <ScreenerList />
          </div>
        </aside>

        <main className="flex-1 flex flex-col md:ml-80 overflow-hidden">
          {/* Add KycNotification below the header */}
          <div className="bg-white shadow-sm flex-shrink-0">
            <KycNotification /> {/* Notification will appear here */}
          </div>

          <div className="p-4 sm:p-6 pb-28 md:pb-6 flex-1 overflow-y-auto">
            <OverviewComponent />
          </div>
        </main>
      </div>
      {/* Add the ChatbotWidget here */}
      <ChatbotWidget /> {/* Chatbot widget at the bottom right corner */}
    </div>
  );
}

export default Dashboard;
